<script>
// 设置工程师modal
import EngineerSelect from "@/views/work-order/components/widgets/engineer-select";
import i18n from "@/i18n";

export default {
  props: {
    title: {
      type: String,
      default: i18n.global.t('page.engineer')
    },
    show: {
      type: Boolean,
      default: false
    },
    companId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      showModal: false,
      engineerId: null
    }
  },
  methods: {
    change(value) {
      this.engineerId = value
    },
    ok () {
      this.$emit('ok', this.engineerId)
    },
    cancel () {
      this.$emit('cancel')
    }
  },
  components: {
    EngineerSelect,
  },
  computed: {
    okDisabled() {
      return !this.engineerId
    }
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        this.showModal = val
      }
    },
    showModal(val) {
      if (!val) {
        this.$emit('cancel')
      }
    },
  }
}

</script>
<template>

  <b-modal v-model="showModal" id="setCompanyModal" hide-footer :title="title" header-class="p-3 bg-light"
           class="v-modal-custom" centered>

    <engineer-select :company-id="companId" @changed="change"></engineer-select>

    <div class="hstack gap-2 justify-content-end mt-5">
      <b-button type="button" variant="light" @click="cancel">
        {{ $t('base.cancel') }}
      </b-button>
      <b-button type="button" variant="success" @click="ok" :disabled="okDisabled">
        {{ $t('base.done') }}
      </b-button>
    </div>

  </b-modal>


</template>
